export default __webpack_public_path__ + "static/media/gridImage9.77ef0c9c.png";